import classNames from 'classnames';

import styles from './FlySpinnerLoader.module.less';

interface FlySpinnerLoaderProps {
  size?: number;
  className?: string;
}

export const FlySpinnerLoader = ({
  size = 24,
  className,
}: FlySpinnerLoaderProps) => {
  const spinnerStyle = {
    width: `${size}px`,
    height: `${size}px`,
  };

  return (
    <div
      className={classNames(styles.spinner, className)}
      style={spinnerStyle}
      data-testid='fly-spinner-loader'
    />
  );
};
